import {
  AdminUserPermissionSet,
  AnnouncementPermissionSet,
  CancellationReasonPermissionSet,
  CommentPermissionSet,
  DevicePermissionSet,
  DriverBreakPermissionSet,
  DriverUserPermissionSet,
  DutyDelayPermissionSet,
  DutyPermissionSet,
  EventPermissionSet,
  OperationalAlertsPermissionSet,
  PermissionSetType,
  PlatformPermissionSet,
  RequestPermissionSet,
  ReviewPermissionSet,
  RiderDriverRestrictionPermissionSet,
  RiderRiderRestrictionPermissionSet,
  ServicePermissionSet,
  SidebarProductVisibilityPermissionSet,
  VehiclePermissionSet,
  VehicleTypePermissionSet,
} from '../sets'

/**
 * Ensure that at the root level of the role, we only add permission sets to it and not
 * individual permissions. Individual permissions at this level will not get assigned to the role.
 * If individual permissions are required, create a permission set of one permission and add to the role.
 */
export const OperationsContractorRole: PermissionSetType[] = [
  // Operations
  PlatformPermissionSet.UsePortal,
  SidebarProductVisibilityPermissionSet.ShowOperationsProduct,

  // Platform User
  AdminUserPermissionSet.View,

  // Driver
  DriverUserPermissionSet.View,

  // Event
  EventPermissionSet.View,

  // Comment
  CommentPermissionSet.View,
  CommentPermissionSet.Write,

  // App Announcements
  AnnouncementPermissionSet.View,

  // Operational Alerts
  OperationalAlertsPermissionSet.Subscribe,

  // Request
  RequestPermissionSet.View,
  RequestPermissionSet.WriteRestricted,
  RequestPermissionSet.ViewConstraintOverrides,
  RequestPermissionSet.ViewDailyCounts,

  // Service
  ServicePermissionSet.View,

  // Vehicle
  VehiclePermissionSet.View,

  // Vehicle Type
  VehicleTypePermissionSet.View,

  // Duty
  DutyPermissionSet.View,
  DutyPermissionSet.New,
  DutyPermissionSet.Edit,
  DutyPermissionSet.Cancel,
  DutyPermissionSet.ViewVehicleLocation,
  DutyPermissionSet.StartDriverConversation,
  DutyPermissionSet.ViewDriverConversation,

  // Driver Break
  DriverBreakPermissionSet.View,
  DriverBreakPermissionSet.Write,
  DriverBreakPermissionSet.ViewReason,
  DriverBreakPermissionSet.WriteReason,
  DriverBreakPermissionSet.DeleteReason,

  // Cancellation Reason
  CancellationReasonPermissionSet.View,

  // Rider-Driver Restriction
  RiderDriverRestrictionPermissionSet.View,

  // Rider-Rider Restriction
  RiderRiderRestrictionPermissionSet.View,

  // Review
  ReviewPermissionSet.View,

  // Duty Delay
  DutyDelayPermissionSet.View,

  // Device
  DevicePermissionSet.View,
]
